module.exports = __webpack_public_path__ + "static/media/msem.05fe111f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/msem.svg
// module id = 276
// module chunks = 0